import { isGlobalLifecycleRole } from "./permissions";
import { useRoles } from "./useRoles";

export const useIsAdmin = () => {
  const roles = useRoles();
  return isGlobalLifecycleRole(roles);
};
